import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = {
  key: 0,
  class: "bg-gray-50 px-6 py-3 rounded-b-lg"
}

import { computed, useSlots } from "vue"
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from "@headlessui/vue"
import { XIcon } from "@heroicons/vue/outline"
import { cn } from "@/shared/utils/helpers"

interface Props {
    open: boolean
    size?: "sm" | "md" | "lg" | "xl" | "3xl"
    hideCloseButton?: boolean
    bodyClass?: string
    fullWidth?: boolean
    headerClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsModal',
  props: {
    open: { type: Boolean },
    size: {},
    hideCloseButton: { type: Boolean },
    bodyClass: {},
    fullWidth: { type: Boolean, default: true },
    headerClass: {}
  },
  emits: ["closeModal"],
  setup(__props: any) {



const props = __props
const slots = useSlots()
const sizes = ["sm:max-w-sm", "sm:max-w-xl", "sm:max-w-lg", "sm:max-w-3xl"]
const sizeClass = computed(() => {
    return [sizes.find((size) => size.includes(props.size as string)) || sizes[1], props.fullWidth ? "w-full" : ""]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "fixed z-40 inset-0",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-100",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["relative inline-block rounded-lg align-middle text-left shadow-xl transform transition-all sm:my-8", sizeClass.value])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(cn)('flex justify-between bg-white rounded-t-lg w-full p-6', _ctx.headerClass))
                  }, [
                    _renderSlot(_ctx.$slots, "header"),
                    (!props?.hideCloseButton)
                      ? (_openBlock(), _createBlock(_unref(XIcon), {
                          key: 0,
                          class: "h-6 w-6 self-center text-gray-400 cursor-pointer hover:text-gray-500",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
                        }))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([
                                _unref(slots).under ? 'rounded-b-none' : 'rounded-b-lg',
                                _unref(cn)('bg-white px-6 pt-1.5 pb-10 overflow-y-auto max-h-[70vh] 2xl:max-h-[80]', _ctx.bodyClass),
                            ])
                  }, [
                    _renderSlot(_ctx.$slots, "default")
                  ], 2),
                  (_unref(slots).under)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "under")
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})